import { FeApi } from '@/api/fe-api';
import {
  type LDPoint,
  type LDSeries,
  type ValuePoint,
  type ValueSeries,
} from '@/warranty-v3/entities/metric';

export function valuePointMapper(data: FeApi.MetricsPoint): ValuePoint {
  return [new Date(data.date), data.value];
}

export function ldPointMapper(data: FeApi.MetricsPoint): LDPoint {
  return [new Date(data.date), data.value];
}

export function valueSeriesMapper(
  data: FeApi.MetricsSeries,
): ValueSeries | undefined {
  if (!data.points) {
    return undefined;
  }

  return {
    points: data.points.map(valuePointMapper),
  };
}

export function ldSeriesMapper(
  data: FeApi.MetricsSeries,
): LDSeries | undefined {
  if (!data.points) {
    return undefined;
  }

  return {
    points: data.points?.map(ldPointMapper),
  };
}
